import * as Yup from 'yup';
import createAgreementModel from "./createAgreementModel";

const {
  formField: {
    clientName,
    clientIdNumber,
    clientAddress,
    clientDob,
    company,
    representedBy,
    purchasePrice,
    unitNumber,
    block,
    paymentsToDate,
    vatPaymentOption,
    vatPaidAmount,
    vatPaidDate,
    firstInstallmentPaymentDate,
    lastInstallmentPaymentDate,
    numberOfInterestFreeMonths,
    propertyDescription,
    unitArea,
    chargeInterest,
    contractReference,
    interestRate,
  }
} = createAgreementModel;

const createAgreementSchema = Yup.object().shape({
  [clientName.name]: Yup.string()
    .required(clientName.requiredErrorMsg),
  [clientIdNumber.name]: Yup.string()
    .required(clientIdNumber.requiredErrorMsg),
  [clientAddress.name]: Yup.string()
    .required(clientAddress.requiredErrorMsg),
  [clientDob.name]: Yup.string()
    .required(clientDob.requiredErrorMsg),
  [company.name]: Yup.string()
    .required(company.requiredErrorMsg),
  [representedBy.name]: Yup.string()
    .required(representedBy.requiredErrorMsg),
  [purchasePrice.name]: Yup.number()
    .nullable()
    .transform(value => (isNaN(value) ? undefined : value))
    .required(purchasePrice.requiredErrorMsg),
  [unitNumber.name]: Yup.string()
    .required(unitNumber.requiredErrorMsg),
  [block.name]: Yup.string()
    .nullable(),
  [paymentsToDate.name]: Yup.array()
    .of(
      Yup.object().shape({
        receiptNumber: Yup.string().required("Receipt Number is required."),
        date: Yup.date().required("Payment date is required."),
        amount: Yup.number().required("Payment amount is required.")
      })
    ),
  [vatPaymentOption.name]: Yup.string()
    .oneOf(['NO_VAT', 'PART_VAT', 'FULL_VAT'])
    .required(vatPaymentOption.requiredErrorMsg),
  [vatPaidAmount.name]: Yup.number()
    .nullable()
    .when(vatPaymentOption.name, {
      is: (value: string) => value === 'PART_VAT' || value === 'FULL_VAT',
      then: schema => schema
        .required(vatPaidAmount.requiredErrorMsg)
        .min(0, vatPaidAmount.invalidErrorMsg),
      otherwise: schema => schema.notRequired(),
    }),
  [vatPaidDate.name]: Yup.date()
    .nullable()
    .when(vatPaymentOption.name, {
      is: (value: string) => value === 'PART_VAT' || value === 'FULL_VAT',
      then: schema => schema.required(vatPaidDate.requiredErrorMsg),
      otherwise: schema => schema.notRequired(),
    }),
  [firstInstallmentPaymentDate.name]: Yup.date()
    .nullable(),
  [lastInstallmentPaymentDate.name]: Yup.date()
    .nullable(),
  [numberOfInterestFreeMonths.name]: Yup.number()
    .required(numberOfInterestFreeMonths.requiredErrorMsg),
  [propertyDescription.name]: Yup.string()
    .required(propertyDescription.requiredErrorMsg),
  [unitArea.name]: Yup.number()
    .required(unitArea.requiredErrorMsg)
    .positive(unitArea.invalidErrorMsg),
  [chargeInterest.name]: Yup.boolean(),
  [interestRate.name]: Yup.number()
    .oneOf([1.25, 1.5], 'Interest rate must be 1.25% or 1.5%')
    .when(chargeInterest.name, {
      is: true,
      then: schema => schema.required(interestRate.requiredErrorMsg),
      otherwise: schema => schema.notRequired(),
    }),
  [contractReference.name]: Yup.string()
    .required(contractReference.requiredErrorMsg)
});


export default createAgreementSchema